// Need to install our custom lodash methods before anything else. - ETC
import 'intersection-observer';

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@acv/shared-vuejs/dist/shared-vuejs.css';
import './assets/css/tailwind.css';
import VueScrollto from 'vue-scrollto';
import Vuelidate from 'vuelidate';
import { TailwindHelper } from '@acv/shared-vuejs';
import tailwindConfig from '../tailwind.config'; // import this project tailwind config

import App from './App.vue';
import store from './store';
import router from './router';
import filters from './filters';

Vue.use(filters);
Vue.use(VueScrollto);
Vue.use(Vuelidate);
Vue.use(TailwindHelper, {
  tailwindConfig,
});

sync(store, router, { moduleName: 'route' });

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
